export const sendPostMessage = (
  message: Record<string, any>,
  id: string
): void => {
  const iframe = document.getElementById(id) as HTMLIFrameElement;

  iframe?.contentWindow?.postMessage(message, '*');
};
